import Configurator from "../../config/Configurator";
import axios from "axios";

export const updateDatabase = async (configName, configValue) => {
  var userID = localStorage.getItem("userID");

  let data = JSON.stringify({
    entity_id: parseInt(userID),
    entity_table: "users",
    name: configName,
    value: JSON.stringify(configValue),
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: (await Configurator()).API_URL + "/v2/db/sqlite/tables/meta/set_one",
    headers: {
      ...axios.defaults.headers.common,
      ...{
        Session: localStorage.getItem("apiKey"),
        "User-Id": localStorage.getItem("userID"),
      },
    },
    data: data,
  };

  return axios.request(config); // Return the promise for chaining if needed
};

/** Write metadata for a specific user (used by admin to set another user's meta). */
export async function updateDatabaseForUser(userId, configName, configValue) {
  const data = JSON.stringify({
    entity_id: parseInt(userId),
    entity_table: "users",
    name: configName,
    value: JSON.stringify(configValue),
  });

  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: (await Configurator()).API_URL + "/v2/db/sqlite/tables/meta/set_one",
    headers: {
      ...axios.defaults.headers.common,
      Session: localStorage.getItem("apiKey"),
      "User-Id": localStorage.getItem("userID"),
    },
    data,
  };

  return axios.request(config);
}
